import React, { Component } from 'react';
import SearchMain from '../../components/Search/search.main';
import LayoutPreload from '../../components/Preload/layout.preload';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import queryString from 'query-string';
import _ from 'lodash';

class SearchPage extends Component {
    componentDidMount() {
        this.handlerSet();
    }

    componentDidUpdate(prevProps) {
        !_.isEqual(prevProps.currentLanguage, this.props.currentLanguage) && this.handlerSet();
    }

    handlerSet = () => {
        const {
            updateWording,
            location,
            keyword,
            KeywordChange,
            SearchItemFormKeyword
        } = this.props;

        const search = queryString.parse(location.search);
        updateWording();
        if (keyword === '') KeywordChange(search.keyword);
        SearchItemFormKeyword(search.keyword);
    }

    render() {
        const { location, searchFetching } = this.props;
        const search = queryString.parse(location.search);

        if (searchFetching) {
            return <LayoutPreload />;
        }
        return <SearchMain searchText={search.keyword} />;
    }
}

const mapStateToProps = ({ search, language }) => ({
    keyword: search.keyword,
    searchFetching: search.searchFetching,
    currentLanguage: language.currentLanguage
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: Actions.updateWording,
            KeywordChange: Actions.KeywordChange,
            SearchItemFormKeyword: Actions.SearchItemFormKeyword
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
